import { useCallback } from "react"
import { CARD_BACK_NOTATION, RANK_MAP, SUIT_MAP } from "../utils/TrucoGameUtils"

export const useTrucoTableLayout = ({
    totalSeats,
    layout,
    trickCount
}) => {

    const safeAccess = (group, seatIndex) => {
        if (
            !layout ||
            !layout[group] ||
            !layout[group][totalSeats] ||
            !layout[group][totalSeats][seatIndex]
        ) {
            return { x: 0, y: 0 }
        }

        return layout[group][totalSeats][seatIndex]
    }

    const getSeatPosition = useCallback(
        (seatIndex) => {
            const pos = safeAccess("seatLayout", seatIndex)
            const { x: pointsX, y: pointsY } = safeAccess("seatPointsLayout", seatIndex)

            return { ...pos, pointsX, pointsY }
        },
        [layout, totalSeats]
    )

    const getCardPosition = useCallback(
        (seatIndex, cardValue, isNoteMe = false) => {
            const pos = safeAccess("cardLayout", seatIndex)
            const width = (cardValue === CARD_BACK_NOTATION || isNoteMe) ? layout?.backCardWidth : layout?.cardWidth || 0
            const height = (cardValue === CARD_BACK_NOTATION || isNoteMe) ? layout?.backCardHeight : layout?.cardHeight || 0
            const backgroundPosition = getCardBackgroundPosition(cardValue, width, height)
            const heightGap = (cardValue === CARD_BACK_NOTATION || isNoteMe) ? layout?.backCardHeightGap : layout?.heightGap
            const widthGap = (cardValue === CARD_BACK_NOTATION || isNoteMe) ? layout?.backCardWidthGap : layout?.widthGap
            const rotation = layout?.rotation
            return { ...pos, width, height, backgroundPosition, heightGap, widthGap, rotation }
        },
        [layout, totalSeats]
    )

    const getCenterCardPosition = useCallback(
        (seatIndex, cardValue) => {
            const pos = safeAccess("centerCardLayout", seatIndex)
            const width = layout?.centerCardWidth || 0
            const height = layout?.centerCardHeight || 0
            const backgroundPosition = getCardBackgroundPosition(cardValue, width, height)
            return { ...pos, width, height, backgroundPosition }
        },
        [layout, totalSeats]
    )

    const getStackCenterCardPosition = useCallback(
        (seatIndex, cardValue, trickCnt = trickCount) => {
            const basePos = safeAccess("stackCenterCardsLayout", seatIndex)
            let width, height, widthGap, x, y
            if (totalSeats === 2) {
                width = layout?.centerCardWidth || 0
                height = layout?.centerCardHeight || 0
                widthGap = layout?.centerCardWidthGap || 0
                x = basePos.x + ((width + widthGap) * (trickCnt - 2) * (totalSeats === 2 ? 1 : 1.45)) // for 2 players, stack vertically, so no horizontal gap increase
                y = basePos.y
            } else {
                width = layout?.centerMultiCardWidth || 0
                height = layout?.centerMultiCardHeight || 0
                widthGap = layout?.centerMultiCardWidthGap || 0
                x = basePos.x + (widthGap * (trickCnt - 2))
                y = basePos.y
            }
            // compute without mutation

            const backgroundPosition = getCardBackgroundPosition(
                cardValue,
                width,
                height
            )
            return { x, y, width, height, backgroundPosition }
        },
        [layout, totalSeats, trickCount]
    )

    const getDealerIconPosition = useCallback(
        (seatIndex) => safeAccess("dealerIconLayout", seatIndex),
        [layout, totalSeats]
    )

    const getTimerPosition = useCallback(
        (seatIndex) => safeAccess("timerPositionLayout", seatIndex),
        [layout, totalSeats]
    )

    const getDigitalTimerPosition = useCallback(
        (seatIndex) => safeAccess("digitalTimerPositionLayout", seatIndex),
        [layout, totalSeats]
    )
    const getCardBackgroundPosition = (card, width, height) => {
        if (!card) return `0px 0px`
        // if (card === CARD_BACK_NOTATION || !card) return `0px 0px`
        const suit = card.slice(-1)
        const rank = card.slice(0, -1)
        const GAP = 0;
        const x = RANK_MAP[rank] * (width + GAP)
        const y = SUIT_MAP[suit] * (height + GAP)


        // return { backgroundPosition: `-${x}px -${y}px`, spriteWidth: 281.25, spriteHeight: 437.5 }
        return { backgroundPosition: `-${x}px -${y}px`, spriteWidth: width * 12, spriteHeight: height * 4 }
    }
    return {
        getSeatPosition,
        getCardPosition,
        getCenterCardPosition,
        getDealerIconPosition,
        getTimerPosition,
        getStackCenterCardPosition,
        getDigitalTimerPosition
    }
}